export const ROUTES = {
  BASE: 'authoring-ai-tools',
  TOOL: 'tool',
  HOME: 'home',
  ATLAS: 'atlas',
};

/** List of all the tools available */
export enum ToolEnum {
  CDF = 'CDF',
  COURSE_MODERNIZER = 'COURSE-MODERNIZER',
  MODULE_INTRO_VIDEO = 'MODULE_INTRO_VIDEO',
  COURSE_OUTLINE = 'COURSE_OUTLINE',
  CONTENT_ITEM_VIDEO = 'CONTENT_ITEM_VIDEO',
  CONTENT_ITEM_READING = 'CONTENT_ITEM_READING',
  FULL_COURSE_ITEM = 'FULL_COURSE_ITEM',
}

/** The prompt mode used by all tools */
export const GLOBAL_PROMPT_MODE = 'CONTENT_ACCELERATION';

export enum ToolWorkflowStep {
  /** The first step where the user decides whether to edit or to generate */
  CHOOSE_PATH = 'CHOOSE_PATH',

  /** Generation is currently in progress. No UI elements are accessible */
  GENERATION_IN_PROGRESS = 'GENERATION_IN_PROGRESS',

  /** Generation was skipped, but the first validation process is running */
  VALIDATION_IN_PROGRESS = 'VALIDATION_IN_PROGRESS',

  /** The editor is currently in use, and at least one validation pass has occurred */
  EDITING = 'EDITING',
}

/** The internal for polling chat history from Coach, 2s */
export const CHAT_HISTORY_POLLING_INTERVAL = 2000;

/** The max number of polling is allowed, equivalent to 5mins */
export const MAX_POLLING_COUNT = 150;
